import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Notiflix from 'notiflix';
import { endpoint } from './endpoint'; // Adjust import according to your project structure
import emailjs from '@emailjs/browser'; // Import EmailJS
import './Verified.css'; // Add CSS for overlay styling
import './Dashboard.css';
import { useUser } from './UserContext';

const Verified = ({ onClose }) => {
    const [isVerified, setIsVerified] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const { user } = useUser();
    const navigate = useNavigate();

    const generateVerificationCode = () => {
        // Generate a random verification code
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    };

    useEffect(() => {
		setIsVerified(user.verified === 0 ? false : true);
        const token = localStorage.getItem('authToken');
        //alert(JSON.stringify(user));
        const checkVerificationStatus = async () => {
            try {
                const response = await fetch(`${endpoint}/gymapp/checkifuserisverified.php`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ token }), // Send the token for authentication
                });

                const result = await response.json();

                if (parseInt(result.verified) === 1) {
                    setIsVerified(true);
                    onClose(); // Close the overlay if verified
                } else if (parseInt(result.verified) === 0) {
                    setIsVerified(false);
                } else {
                    Notiflix.Report.failure('Unexpected response from the server.');
                }
            } catch (error) {
               // Notiflix.Report.failure('An error occurred while checking verification status. Please try again.');
            }
        };

        if (!isVerified) {
            checkVerificationStatus();

            // Set up long polling
            const intervalId = setInterval(checkVerificationStatus, 5000); // Poll every 5 seconds

            // Cleanup function to clear the interval
            return () => clearInterval(intervalId);
        }
    }, [navigate, onClose, user.verified]);

    const handleSendVerificationEmail = async () => {
        const userData = JSON.parse(localStorage.getItem('userData'));
        const { email, name } = userData;
        const generated_code = generateVerificationCode();
        const templateParams = {
            to_email: email,
            to_name: name,
            verification_link: `${endpoint}/gymapp/verifyuser.php?code=${generated_code}&email=${email}`,
        };

        try {
            const result = await emailjs.send('service_1gmfr9p', 'template_ap681fw', templateParams, 'oHDaECTPiJ7CvCMvW');

            if (result.status === 200) {
                setEmailSent(true);
                Notiflix.Notify.success('Verification email sent. Please check your inbox.');
                await fetch(`${endpoint}/gymapp/save_code.php?code=${generated_code}&email=${email}`);
            } else {
                Notiflix.Report.failure('Failed to send verification email. Please try again.');
            }
        } catch (error) {
            Notiflix.Report.failure('An error occurred while sending the verification email. Please try again.');
        }
    };

   

    return (
        <>
            {!isVerified && (
                <div className={`notification-bar ${isVerified ? 'verified' : 'not-verified'} justify-content-center`}>
                    { (
                        <div className="notification-message text-center">
                            <div>
                                {!emailSent && (
                                    <>
                                        <h2>Your account is not verified!</h2>
                                        <br />
                                        <p>Please complete the verification process to access all features.</p>
                                    </>
                                )}
                                {emailSent ? (
                                    <p style={{ color: 'green' }}>
                                        An email has been sent. Please check your inbox to verify your account.
                                    </p>
                                ) : (
                                    <button
                                        className="btn btn-success form-control"
                                        onClick={handleSendVerificationEmail}
                                    >
                                        Send verification email
                                    </button>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default Verified;
